export default __webpack_public_path__ + "static/media/beergif.f1077083.gif";